import React, { useRef } from 'react'
import { Toast } from 'primereact/toast'
import ToastContext from './ToastContext'
import { globalConfig } from '../../../globalConfig'

const ToastProvider = ({ children }) => {
    const toast = useRef(null)

    const triggerToast = (params) => {
        toast.current.show({
            life: globalConfig.toast.life,
            ...params,
        })
    }

    return (
        <ToastContext.Provider
            value={{
                triggerToast,
            }}
        >
            <Toast ref={toast} />
            {children}
        </ToastContext.Provider>
    )
}

export default ToastProvider
